import trackError from 'src/lib/rollbar';

/*
 * Email validation regex based on RFC 2822 official standard.
 */
const EMAIL_VALIDATION_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

/*
 *
 * Validate if an email is valid.
 * Specification for valid email is based on RFC 2822 official standard.
 * @param {string} emailAddress
 * @return {boolean}
 */
const isValidEmailAddress = (emailAddress) =>
  EMAIL_VALIDATION_REGEX.test(emailAddress);

export default {
  isValidEmailAddress,
};
